import React, { Fragment, useRef, useState, useEffect, use } from 'react'
import PopUp from '../Common/PopUp';
import Filter from '../Common/Filter';
import Table from '../Common/Table';
import { showToast } from '../Common/Messages';
import { useSelector } from 'react-redux';
import { dateFormat } from '../libs/Util';

const ProdectsMenagement = () => {
    const loginInfo = useSelector(state => state.login);
    const loginUserId = loginInfo.userId;

    const [popupContent, setPopupContent] = useState(null);
    const [productsList, setProductsList] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        getProductsList();
    }, []);



    const getProductsList = () => {
        fetch('datas/oper/products.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            }
        }).then((response) => response.json())
            .then((data) => {
                setProductsList(data);
            });
    }

    const handleChange = (product, field, value) => {
        product[field] = value === "true";
        setProductsList([...productsList]);
    }

    const handleDeleteProduct = (group) => {
        
    };

    const btnOnPopup = (e, item, index, type) => {
        setPopupContent(item !== null && item !== undefined
            ? renderMoreMenu(e, item, index, type) : null);
    }

    const renderMoreMenu = (e, item, index, type="menu") => {
        return (
            <div className="context-menu" style={{ top: e.clientY + 'px', left: e.clientX + 'px'}}>
                <ul>
                    <li onClick={() => handleDeleteProduct(item.route)}><a className='default'>삭제</a></li>
                </ul>
            </div>
        )
    }

    const renderGroupList = () => {
        return productsList.map((product, index) => {
            return (
                <tr>
                    <td></td>
                    <td>{product.name}</td>
                    <td>{product.url}</td>
                    <td>{product.text}</td>
                    <td>{product.class}</td>
                    <td>
                        <select value={product.visible === false ? "false" : "true"} onChange={e => handleChange(product, "visible", e.target.value)}>
                            <option value={"true"}>표시</option>
                            <option value={"false"}>숨김</option>
                        </select>
                    </td>
                    <td>
                        <select value={product.isLogin === true ? "true" : "false"} onChange={e => handleChange(product, "isLogin", e.target.value)}>
                            <option value={"false"}>전체</option>
                            <option value={"true"}>로그인</option>
                        </select>
                    </td>
                    {/* <td><button className="btn-admin-more" onClick={e => btnOnPopup(e, product, index)}><i className="i-btn-more"></i></button></td> */}
                </tr>
            )
        })
    };

    // const list = renderGroupList();
    // const list = useMemo(() => renderGroupList(), [productsList]);

    const setHeaders = () => {
        return [
            "",
            "제품명",
            "링크",
            "설명",
            "클래스",
            "표시 여부",
            "접근 권한",
            ""
        ];
    };

    const saveProduct = () => {
        const body = {
            menuPath: "oper/products",
            menuTreeJson: JSON.stringify(productsList)
        }

        fetch('api/Manager/SaveMenu', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        })
            .then(response => response.json())
            .then(data => {
                if (data.message === "Success") {
                    showToast('success', '저장이 완료되었습니다.', 3000);
                    // 재로딩
                    getProductsList();
                }
            })
            .catch(error => {throw new Error('Error saving menu: ' + error)});
    };

    return (
        <div className="content-scroll">
            <div className="content">
                <div className="content-right">
                    <h3 className='list-title mb-12'></h3>
                    <div className="list-tools" style={{display:"flex", justifyContent: "flex-end"}}>
                        <div className={`btns-wrap`}>
                            {/* <button className='btn-appr' onClick={() => {showToast('warning', '추가 기능은 추후 제공됩니다.', 3000)}}>
                                <i className='icoKdc12 add-12'></i>
                            </button> */}
                            <button className='btn-appr' onClick={() => {saveProduct()}}>
                                저장
                            </button>
                        </div>
                    </div>
                    <Table className={"userlist"} headers={setHeaders()} list={renderGroupList()} />
                    <PopUp setContent={() => btnOnPopup()} content={popupContent} />
                </div>
            </div>
        </div>
    );
}

export default ProdectsMenagement;